module.exports = {"id":"dp1_3l3q2","text":"Managing Information","instructions":"What is the main benefit of applying consistent file naming conventions?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.3","questionType":"PickOne","random":true,"options":[{"id":"dp1_3l3q2-a1","text":"Easier searching and retrieval","score":3.7},{"id":"dp1_3l3q2-a2","text":"Increased file compression","score":1.3},{"id":"dp1_3l3q2-a3","text":"Improved device performance","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.3/l3q2.json
// module id = 972
// module chunks = 41